/** localStorage 键：上次完成妥投时选择的妥投方式 在完成妥投时写入，进入妥投页面时读取*/
export const LAST_DELIVERY_METHOD_STORAGE_KEY = 'delivery.lastDeliveryMethod';

export const getLastDeliveryMethod = (): string | null =>
    localStorage.getItem(LAST_DELIVERY_METHOD_STORAGE_KEY);

export const setLastDeliveryMethod = (code: string): void =>
    localStorage.setItem(LAST_DELIVERY_METHOD_STORAGE_KEY, code);
